import { MaintenanceObjectiveActionsData } from "@/features/maintenance/types/MaintenanceObjectiveActions.type";
import { DiagnosticActivityData, DiagnosticPieceData, MaintenanceForwardingDirectiveEntryDiagnosticEntryData } from "./diagnosticEntry/diagnosticEntry.type";
import { MaintenanceObjectivePartsData } from "@/features/maintenance/types/MaintenanceObjectiveParts.type";
import { MaintenanceObjectiveSystemData } from "@/features/maintenance/types/MaintenanceObjectiveSystem.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "../maintenanceForwardingsDirectiveEntryKlasses.type";
import { MaintenanceForwardingDirectiveEntryExecutionEntryData } from "./executionEntry/executionEntry.type";
import { LastReview } from "@/features/company/types/company.type";
import { File } from "@/common/types/file";

export enum MaintenanceForwardingDirectiveEntryStatus {
  Pending = 'pending',
  AwaitingManualStart = 'awaiting_manual_start',
  InProgress = 'in_progress',
  AwaitingClientReview = 'awaiting_client_review',
}

export type MaintenanceDirectiveObjectiveData = {
  action: MaintenanceObjectiveActionsData;
  diagnostic_activities?: DiagnosticActivityData[];
  execution_activities?: DiagnosticActivityData[];
  diagnostic_pieces?: DiagnosticPieceData[];
  execution_pieces?: DiagnosticPieceData[];
  does_not_need_estimate: boolean;
  id: string;
  last_review?: LastReview;
  part: MaintenanceObjectivePartsData;
  photos: File[];
  system: MaintenanceObjectiveSystemData;
  status: string;
}

export type MaintenanceForwardingDirectiveEntryMap = {
  [MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry]: MaintenanceForwardingDirectiveEntryDiagnosticEntryData;
  [MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry]: MaintenanceForwardingDirectiveEntryExecutionEntryData;
  [MaintenanceForwardingsDirectiveEntryKlass.ScrapEntry]: undefined;
}
